export const subscriptionList = {
  showCheckboxLabel: 'Show only active subscriptions',
  emptyState: {
    title: 'Create your first subscription',
    text: `It looks like you haven't made a purchase yet. Get comprehensive nutrition and gut health support in one simple scoop.`,
    button: 'Get Your AG1'
  },
  subscriptionCard: {
    titleOrder: 'Next Order:',
    titleSubscription: 'Subscription Products:',
    activeLabel: 'Active',
    cancelLabel: 'Canceled',
    frequencyTitle: 'Frequency:',
    frequencyDayText: 'Every',
    manageSubscriptionButton: 'Manage Subscription',
    subscriptionDetailsButton: 'Subscription Details',
    reactivateButton: 'Reactivate',
    orderDateLabel: 'Order Date:',
    orderTotalLabel: 'Order Total:',
    productsSubtitle: 'Products:',
    subscriptionDetailsSubtitle: 'Subscription Details'
  },
  cancelList: {
    title: 'Cancelled Subscriptions',
    description: `Reactivate your subscription to get AG1 on your schedule. Once your subscription is active, you can edit your preferences and shop the full range of AG1 products.`
  }
};
